import React, { PureComponent } from 'react';
import { Text, ScrollView, ActivityIndicator } from 'react-native';
import { createContainer } from '@dbk-legacy/muster/react';
import PropTypes from 'prop-types';
import { View } from '@dbk/ui-react-utils';
import { StyleSheet } from 'react-native'
import { NotificationWarning } from '@dbk/ui-icons';
import { Accordion, AccordionItem } from '@dbk/ui-accordion';
import find from 'lodash/find';
import pullAll from 'lodash/pullAll';
import pull from 'lodash/pull';
import filter from 'lodash/filter';
import findIndex from 'lodash/fp/findIndex';
import map from 'lodash/map';
import assign from 'lodash/assign';
import ReportCategoryDocListItem from './report-category-doclist-item';
import ReportUnreCategoryDocListItem from './report-unread-category-doclist-item';
import ReportCategoryListHeader from './report-category-list-header';
import ReportMarkReadOrDownload from './report-mark-read-download';
import { EDELIVERY, SELECTED_RANGE, CSV, PDF, TXT, SUCCESS_RESPONSE_CODE, SCROLL_DIRECTION, ITEM_PER_PAGE, FILTER_CATEGORY } from '../constants';
import { AccordionPlusIcon, AccordionMinusIcon } from '../../../../../../src/components/common/icons';
import ReportCategorySelectAll from './report-category-select-all';
import ReportEmptyData from './report-empty-data';
import BlurModal from '../../../../../../src/components/common/blur-modal';
import AttachmentDownload from '../../../../../../src/utils/attachment-download';
import download from '../../../../../../src/muster/utils/downloader';
import { LoadingCircle } from '../../../../../../src/components/common/loading';
import { PALETTE } from '../../../../../../src/constants';
import additionalStyles from './report-category.styles'

  import {
    getDocumentName
  } from '../../../../../../src/components/common/reports-name-conventions/reports-name-conventions';
import Button, { ButtonGroup } from '@dbk/ui-buttons';
import { Large } from '../../../../../../src/components/common/text';


let itemsForRendering = [];
let lastScrollPosition = 0;
class ReportCategoryDocList extends PureComponent {

    state = {
        isSelectAllChecked: false,
        isSelectAllIndeterminate: false,
        isCategoryChecked: false,
        isShowUnreadOnlyChecked: false,
        selectedIdsForMarkAsRead: [],
        selectedCategoryList: [],
        unreadList: [],
        showMarkAsRead: false,
        checkedItemList: [],
        hideWarning: true,
        selectedIdsForDownload: [],
        downloadLoadingFlag: false,
        activeAccordionItem: [],
        nextOffset: 1,
        newDocObj:'',
        selectedIdsForIndivisualDownload: [],
        individualDownload: false
    }

    componentDidMount() {
        this.modifyDefaultListAndUnredListWithReadProperty();
    }

    componentDidUpdate(prevProps, prevState) {
        const {
            reports: {
                selectedCategoryId,
            selectedReportDetailsDateRange,
            statement: {
                    customRangeList, customRangeUnreadList,
                lastWeek, lastWeekUnread,
                lastMonth, lastMonthUnread } } } = this.props;

        if ((prevProps.reports.selectedCategoryId && prevProps.reports.selectedCategoryId
            !== selectedCategoryId) || (prevProps.reports.selectedReportDetailsDateRange !== selectedReportDetailsDateRange) ||
            (prevProps.reports.statement.customRangeList !== customRangeList
                || prevProps.reports.statement.customRangeUnreadList !== customRangeUnreadList) ||
            (prevProps.reports.statement.lastWeek !== lastWeek
                || prevProps.reports.statement.lastWeekUnread !== lastWeekUnread) ||
            (prevProps.reports.statement.lastMonth !== lastMonth
                || prevProps.reports.statement.lastMonthUnread !== lastMonthUnread)
        ) {
            this.modifyDefaultListAndUnredListWithReadProperty();
            this.handlePaginationChange();
        }

    }


    /**
    * resetting state
    */
    resetState() {
        this.setState(
            {
                isSelectAllChecked: false,
                isSelectAllIndeterminate: false,
                isCategoryChecked: false,
                isShowUnreadOnlyChecked: false,
                selectedIdsForMarkAsRead: [],
                selectedCategoryList: [],
                unreadList: [],
                showMarkAsRead: false,
                checkedItemList: [],
                hideWarning: false,
                selectedIdsForDownload: [],
                downloadLoadingFlag: false,
                activeAccordionItem: [],
                nextOffset: 1
            }
        );
    }

    /**
     * adding isChecked and isIndeterminate properties to the
     * category and documents.
     */
    modifyDefaultListAndUnredListWithReadProperty = () => {
        this.resetState();
        let defaultList = [];
        let defaultUnreadList = [];
        const { reports: { selectedCategoryId, statement: { lastWeek,
            lastMonth, lastWeekUnread, lastMonthUnread,
            customRangeList, customRangeUnreadList, last90days },
            selectedReportDetailsDateRange } } = this.props;

        if (selectedReportDetailsDateRange === SELECTED_RANGE.CUSTOM) {
            defaultList = this.getModifiedDefaultList(customRangeList);
            defaultUnreadList = this.getModifiedUnreadList(customRangeUnreadList);
        }
        else {
            // iterate through list and unreadStatementList to add isChecked property
            defaultList = (selectedReportDetailsDateRange === SELECTED_RANGE.LAST_WEEK) ?
                lastWeek : (selectedReportDetailsDateRange === SELECTED_RANGE.LAST_MONTH) ? lastMonth : last90days;
            defaultList = this.getModifiedDefaultList(defaultList);

            defaultUnreadList = (selectedReportDetailsDateRange === SELECTED_RANGE.LAST_WEEK) ?
                lastWeekUnread : lastMonthUnread;
            defaultUnreadList = this.getModifiedDefaultList(defaultUnreadList);

        }
        if (selectedCategoryId === EDELIVERY.UNREAD_CATEGORY_ID)
            this.setTotalDocs(lastWeekUnread, lastMonthUnread, customRangeUnreadList);
        else {
            const selectedCategoryWeekList = this.getReportListById(lastWeek, selectedCategoryId);
            const selectedCagtegoryMonthList = this.getReportListById(lastMonth, selectedCategoryId)
            const selectedCagtegory90daysList = this.getReportListById(last90days, selectedCategoryId)
            const customRangeData = this.getReportListById(customRangeList, selectedCategoryId);

            this.props.setTotalDocs(selectedCategoryWeekList ? selectedCategoryWeekList.documentMetadataList.length : 0,
                selectedCagtegoryMonthList ? selectedCagtegoryMonthList.documentMetadataList.length : 0,
                selectedCagtegory90daysList ?  selectedCagtegory90daysList.documentMetadataList.length : 0,
                customRangeData ? customRangeData.documentMetadataList.length : 0);
        }
        this.setCategoryListAndUnreadCategoryList(selectedCategoryId, defaultList, defaultUnreadList);
    }

    getModifiedDefaultList = (list) => {
        if (list && list.length > 0) {
            list.map((item) => {
                const category = item;
                category.categoryChecked = false;
                const updatedMetaDataList = map(category.documentMetadataList, o => assign(o, { checked: false }));
                category.documentMetadataList = updatedMetaDataList;
                return item;
            })
        }
        return list;
    }

    getModifiedUnreadList = (defaultUnreadList) => {
        if (defaultUnreadList) {
            defaultUnreadList.map((item) => {
                const category = item;
                category.categoryChecked = false;
                const updatedMetaDataList = map(category.documentMetadataList, o => assign(o, { checked: false }));
                category.documentMetadataList = updatedMetaDataList;
                return item;
            })
        }
        return defaultUnreadList;
    }

    // setCategoryListAnd unread category list
    setCategoryListAndUnreadCategoryList = (selectedCategoryId, list, unreadList) => {
        // find object from list by selected categoryId
        const selectedList = this.getReportListById(list, selectedCategoryId);
        this.setState({
            selectedCategoryList: (selectedList && selectedList.documentMetadataList) ? selectedList : [],
            unreadList
        });
    }

    /**
     * handle report/document list item click
     * TODO:: refacor code, implementation in progress
     */
    handleReportItemClick = (documentObj) => {
        if (documentObj) {
            this.setState({ newDocObj: documentObj, individualDownload: false });
            let newCheckedList = [];
            const selectedIdsForMarkAsRead = [...this.state.selectedIdsForMarkAsRead];
            const selectedIdsForDownload = [...this.state.selectedIdsForDownload];
            const { reports: { selectedCategoryId } } = this.props;
            let filteredDocumentCategoy;
            let categoryIndex;
            let list;
            let isAllSelected = false;
            // if selected category is unread
            if (selectedCategoryId === EDELIVERY.UNREAD_CATEGORY_ID) {
                list = [...this.state.unreadList];
                categoryIndex = list.findIndex(ele => ele.docCategoryId.includes(documentObj.categoryIds[0]));
                filteredDocumentCategoy = list.find(ele => ele.docCategoryId.includes(documentObj.categoryIds[0]));
            } else {
                filteredDocumentCategoy = { ...this.state.selectedCategoryList };
            }

            if (filteredDocumentCategoy && filteredDocumentCategoy.documentMetadataList
                && filteredDocumentCategoy.documentMetadataList.length > 0) {
                const checkedDocument = find(filteredDocumentCategoy.documentMetadataList,
                    { documentId: documentObj.documentId });
                const checkedDocumentIndex = findIndex({ documentId: documentObj.documentId },
                    filteredDocumentCategoy.documentMetadataList);
                // TODO:: Need to check for indermediate state also
                if (documentObj.checked) {
                    // added for download functionality
                    newCheckedList = [...this.state.checkedItemList];
                    for (let i = 0; i < Object.keys(newCheckedList).length; i++) {
                        if (newCheckedList[i].documentId === checkedDocument.documentId) {
                            newCheckedList.splice(i, 1);
                        }
                    }

                    checkedDocument.checked = false;
                    filteredDocumentCategoy.categoryChecked = false;
                    pull(selectedIdsForMarkAsRead, documentObj.documentId);
                    pull(selectedIdsForDownload, documentObj.documentId);
                } else {
                    // added for download functionality
                    const checkedItem = { documentId: checkedDocument.documentId, documentName: getDocumentName(checkedDocument) };
                    newCheckedList.push(checkedItem);
                    newCheckedList = [...this.state.checkedItemList, ...newCheckedList];


                    checkedDocument.checked = true;
                    if (!documentObj.read) {
                        selectedIdsForMarkAsRead.push(documentObj.documentId);
                    }
                    selectedIdsForDownload.push(documentObj.documentId);

                }



                filteredDocumentCategoy.documentMetadataList[checkedDocumentIndex] = checkedDocument;
                // check if the category is checked or not
                const isSelectedCategoryChecked = this.checkAllItemCheckedInCategory(filteredDocumentCategoy);
                if (isSelectedCategoryChecked)
                    filteredDocumentCategoy.categoryChecked = isSelectedCategoryChecked;

                if (list && list.length > 0) {
                    list[categoryIndex] = filteredDocumentCategoy;
                    isAllSelected = this.checkAllItemCheckedInUnreadList(list);
                    this.setState({
                        unreadList: list,
                        selectedIdsForMarkAsRead,
                        selectedIdsForDownload,
                        isSelectAllChecked: isAllSelected,
                        checkedItemList: newCheckedList
                    });
                } else {
                    // there is only one category, so isSelectedCategoryChecked is used for
                    // selectAllChecked
                    this.setState({
                        selectedCategoryList: filteredDocumentCategoy,
                        isSelectAllChecked: isSelectedCategoryChecked,
                        selectedIdsForMarkAsRead,
                        selectedIdsForDownload,
                        checkedItemList: newCheckedList
                    })
                }
            }

        }
    }

    clearCheckedDownloadItems = () => {
        const { checkedItemList, selectedIdsForDownload, selectedCategoryList } = this.state;
        const checkedIDs = new Set(checkedItemList.map(doc => doc.documentId));
        const updateMetaList = selectedCategoryList.documentMetadataList.map(metaDoc => {
            if(checkedIDs.has(metaDoc.documentId)){
                return { ...metaDoc, checked: false};
            }
            return metaDoc;
        });
        this.setState(prevState => ({
            selectedCategoryList: {
                ...prevState.selectedCategoryList,
                documentMetadataList: updateMetaList
            }
        }))
        this.setState({
            selectedIdsForDownload: [],
            checkedItemList: [],
            selectedIdsForMarkAsRead: [],
            downloadLoadingFlag: false,
            selectedIdsForIndivisualDownload: [],
            isSelectAllChecked: false
        });
        
    }

    /**
     * function to check if all items in unread list are checked or not
     * if not select all checkbox will be unchecked
     */
    checkAllItemCheckedInUnreadList = (unreadList) => {
        const unreadCategoryList = unreadList;
        const checkedList = filter(unreadCategoryList, (o) => (o.categoryChecked === false));
        if (checkedList && checkedList.length > 0) {
            return false;
        }
        return true;
    }

    /**
    * function to check if all items in category are checked or not
    * if not select all checkbox will be unchecked
    */
    checkAllItemCheckedInCategory = (selectedList) => {
        const selectedCategoryList = { ...selectedList };
        const checkedList = filter(selectedCategoryList.documentMetadataList, (o) => (o.checked === false));
        if (checkedList && checkedList.length > 0) {
            return false;
        }
        return true;
    }

    /**
     * method to handle category click in accordion
     */
    handleCategoryClick = (documentCategoryId) => {
        let newCheckedList = [];
        const unreadCategoryList = [...this.state.unreadList];
        let selectedIdsForDownload = [...this.state.selectedIdsForDownload];
        const checkedCategoryList = find(unreadCategoryList, { docCategoryId: documentCategoryId });
        const index = findIndex({ docCategoryId: documentCategoryId }, this.state.unreadList);
        let documentList = this.state.selectedIdsForMarkAsRead;
        if (checkedCategoryList) {
            // check if category is checked or indeterminate
            if (checkedCategoryList.categoryChecked || checkedCategoryList.categoryIndeterminate) {
                checkedCategoryList.documentMetadataList.map(item => {
                    documentList = pull(documentList, item.documentId);
                    documentList = pull(selectedIdsForDownload, item.documentId);
                    item.checked = false;
                })
                checkedCategoryList.categoryChecked = false;
            } else {
                checkedCategoryList.documentMetadataList.map(item => {
                    if (documentList && documentList.indexOf(item.documentId) < 0 && !item.read) {
                        documentList.push(item.documentId)
                    }
                    item.checked = true;
                    const checkedItem = { documentId: item.documentId, documentName: getDocumentName(item) };
                    newCheckedList.push(checkedItem);
                    selectedIdsForDownload.push(item.documentId);
                })
                newCheckedList = [...this.state.checkedItemList, ...newCheckedList];
                checkedCategoryList.categoryChecked = true;
            }
            // TODO:: replace item at index
            unreadCategoryList[index] = checkedCategoryList;
            selectedIdsForDownload = selectedIdsForDownload.filter((item, i, ar) => ar.indexOf(item) === i);
            this.setState({
                unreadList: unreadCategoryList,
                selectedIdsForMarkAsRead: documentList,
                isSelectAllChecked: this.checkAllItemCheckedInUnreadList(unreadCategoryList),
                checkedItemList: newCheckedList,
                selectedIdsForDownload
            });
        }
    }

    /**
     * get report list by selected id
     */
    getReportListById = (list, selectedCategoryId) => find(list,
        { docCategoryId: selectedCategoryId })

    /**
    * method to handle onPress of Mark as Read
    */
    handleMarkasReadOnclick = () => {
        this.props.markDocumentsAsRead(this.state.selectedIdsForMarkAsRead)
    }

    downloader =() => {
        // 16560003 csv
        // 13681003, 13687003, 13693003, 13696003, 13679003, 13680003, 13683003, 13689003, 13690003, 13697003, 13675003, 13676003
        // const filesToDownload = [13674003]; // 13678003, 13681003, 13687003, 13693003, 13696003, 13679003, 13680003, 13683003, 13689003, 13690003, 13697003, 13675003, 13676003];
        const {
            settings: { currentEnvironment: { remoteUrl } },
            auth: { userId, authHeader, langCode },
            i18n: { messages }
        } = this.props;

        const RSA_URL = remoteUrl + '/edelivery/' + this.props.app.config.apiverion + '/downloadDocumentsInBinary';

        this.props.setShowSpinnerReport(true);
        for (let j = 0; (j < this.state.selectedIdsForDownload.length || j < this.state.selectedIdsForIndivisualDownload.length); j++) {
            const body = { "userId": userId, "branchCode": this.props.app.user.selectedPortfolio.branchCode, "channel": "WEB", "language": langCode, "documentIds": !this.state.selectedIdsForIndivisualDownload.length ? [this.state.selectedIdsForDownload[j]]:[this.state.selectedIdsForIndivisualDownload[j]] };
            let documentName = '';
            documentName = this.state.checkedItemList[j].documentName;
            const that = this;

            const x = new XMLHttpRequest();
            x.open('POST', RSA_URL, true);
            x.setRequestHeader('Authorization-Token', authHeader);
            x.setRequestHeader('content-type', 'application/json');
            x.setRequestHeader('Accept', 'application/octet-stream');
            // x.setRequestHeader('Authorization', 'Bearer dd6eee37bae42619bdcfa28b48ab9125');
            // x.setRequestHeader("Access-Control-Allow-Origin", "*");
            // x.setRequestHeader("Access-Control-Allow-Credentials", "true");
            // x.setRequestHeader("Access-Control-Allow-Methods", "GET,HEAD,OPTIONS,POST,PUT");
            // x.setRequestHeader("Access-Control-Allow-Headers", "Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers");

            x.setRequestHeader(
                'Content-Disposition',
                'inline; filename=' + documentName
            );
            x.setRequestHeader(
                'Cache-Control',
                'no-cache, no-store, must-revalidate'
            );
            x.setRequestHeader('Pragma', 'no-cache');
            x.setRequestHeader('Expires', '0');
            x.responseType = 'arraybuffer';
            x.timeout = 300000;
            x.ontimeout = function () {
                that.props.setShowSpinner(false); that.props.setBlurModalError(messages['app.chedelivery.reports.systemErrorMessage']);
            }

            x.onload = function (e) {
                if (x.status === SUCCESS_RESPONSE_CODE) {
                    const documentType = x.getResponseHeader('content-type');
                    // const ext = documentType.split('/');
                    let ext = '';
                    if (documentType.includes('/pdf')) {
                        ext = PDF;
                    } else if (documentType.includes('/csv')) {
                        ext = CSV;
                    } else if (documentType.includes('/text')) {
                        ext = TXT;
                    }

                    download(x.response, documentName + ext, documentType); // text/csv and
                    // if ((that.state.selectedIdsForDownload.length > 0 && (j === that.state.selectedIdsForDownload.length - 1)) || (that.state.selectedIdsForIndivisualDownload.length >0 && (j === that.state.selectedIdsForIndivisualDownload.length - 1))) {
                    //     if (that.props.reports.selectedReportDetailsDateRange === SELECTED_RANGE.CUSTOM) {
                    //         // that.props.getCustomRangeDocuments(that.props.reports.startDate, that.props.reports.endDate);
                    //         that.props.getCustomRangeDocuments(that.props.reports.startDate, that.props.reports.endDate).then(() => {
                    //             that.setState({ downloadLoadingFlag: false });
                    //         });
                    //     } else {
                    //         // that.props.getDocuments().then(() => {
                    //             that.setState({ downloadLoadingFlag: false, selectedIdsForDownload:[], selectedIdsForIndivisualDownload: [], checkedItemList:[] });
                    //         // });
                    //     }
                    // }
                    that.props.getDocuments();    //WMCE-46390-To update status of badge upon clicking download 
                } else {
                    that.props.setBlurModalError(messages['app.chedelivery.reports.systemErrorMessage']);
                    download(x.response, documentName + '.pdf', 'pdf'); // text/csv and
                }
                
                // that.props.setShowSpinner(false);
                that.props.setShowSpinnerReport(false);
            };

            x.send(JSON.stringify(body));

            x.onerror = function (e) {
                // that.props.setShowSpinner(false);
                that.props.setShowSpinnerReport(false);
                that.props.setBlurModalError(messages['app.chedelivery.reports.systemErrorMessage']);
            };
        }
        this.clearCheckedDownloadItems();
    }

    /**
    * method to handle onPress of Download/ Preview
    */
    handlePreviewnDownloadClick = () => {
        // this.props.downloadDocuments(this.state.selectedIdsForDownload[0]);
        this.setState({ downloadLoadingFlag: true, individualDownload:false });
        this.downloader();
    }

    /**
     * function to downlaod invidual reports
     */
    downloadIndividualReport = ({...item}) =>{
        
        const selectedIdsForDownload = [item.documentId];
        
        item.documentName = getDocumentName(item); // doc name should be sync with download button functionality(check box click with download button )
        const checkedItemList = [item, ...this.state.checkedItemList];
        this.setState({  
            selectedIdsForIndivisualDownload: selectedIdsForDownload,
            checkedItemList: checkedItemList,
            individualDownload: true,
            selectedIdsForDownload: [],
            isSelectAllChecked: false,
        }, () => this.downloader() )
        
    }

    /**
     * method to handle select all checkbox click.
     * this will store all selected report ids into an array.
     * later, the array will be used for 'Mark as read' functionality
     */
    handleSelectAllClick = () => {
        let isChecked = false;
        if (this.state.isSelectAllChecked) {
            isChecked = false;
        } else {
            isChecked = true;
        }
        // storing selected documents list in state, which will be used for mark as read
        this.setItemsAsCheckedOrUnchecked(isChecked);
    }

    /**
         * function to handle Show Unread Only check box click.
         * only unread documents/report list should be displayed on check of the
         */
    handleShowUnreadOnlyClick = () => {
        if (this.state.isShowUnreadOnlyChecked) {

            this.modifyDefaultListAndUnredListWithReadProperty();
            this.setState({
                isShowUnreadOnlyChecked: false,
                isSelectAllChecked: false

            });
            this.props.reports.setShowUnreadOnlyChecked(false);

            return;
        }
        const selectedList = { ...this.state.selectedCategoryList };
        const filteredUnreadList = filter(selectedList.documentMetadataList, { read: false });
        selectedList.documentMetadataList = filteredUnreadList;
        this.setState({
            selectedCategoryList: selectedList,
            isShowUnreadOnlyChecked: true,
            selectedIdsForDownload: this.state.selectedIdsForMarkAsRead
        });
        this.props.reports.setShowUnreadOnlyChecked(true);

    }

    // TODO:: code refactoring
    setItemsAsCheckedOrUnchecked = (isChecked) => {
        const { reports: { selectedCategoryId } } = this.props;
        const documentsIdList = [];
        const newCheckedList = [];
        const selectedIdsForDownload = [...this.state.selectedIdsForDownload];
        if (isChecked) {
            if (selectedCategoryId === EDELIVERY.UNREAD_CATEGORY_ID) {
                const unreadList = [...this.state.unreadList];
                unreadList.map((item) => {
                    item.categoryChecked = true;
                    item.documentMetadataList.map((document) => {
                        if (documentsIdList.indexOf(document.documentId) < 0 && !document.read) {
                            documentsIdList.push(document.documentId)
                        }
                        document.checked = true;

                        if (!selectedIdsForDownload.includes(document.documentId)) {
                            selectedIdsForDownload.push(document.documentId);
                            const checkedItem = { documentId: document.documentId, documentName: getDocumentName(document) };
                            newCheckedList.push(checkedItem);
                        }
                    })
                })
            } else {
                const selectedCategoryList = { ...this.state.selectedCategoryList };// this.getReportListById(this.state.selectedCategoryList, selectedCategoryId);
                const filteredData  = this.filterCategoryList(selectedCategoryList.documentMetadataList);
                filteredData.map((item) => {
                    // checking if document is not read and documentId is not present in the array
                    // then push into the array
                    if (isChecked && !item.read) {
                        documentsIdList.push(item.documentId)
                    }
                    item.checked = true;

                    if (!selectedIdsForDownload.includes(item.documentId)) {
                        selectedIdsForDownload.push(item.documentId);
                        const checkedItem = { documentId: item.documentId, documentName: getDocumentName(item) };
                        newCheckedList.push(checkedItem);
                    }

                })
            }
        } else {
            if (selectedCategoryId === EDELIVERY.UNREAD_CATEGORY_ID) {
                const unreadList = [...this.state.unreadList];
                unreadList.map((item) => {
                    item.categoryChecked = false;
                    item.documentMetadataList.map((document) => {
                        document.checked = false;
                    })
                })
            } else {
                const selectedCategoryList = { ...this.state.selectedCategoryList };
                selectedCategoryList.documentMetadataList.map((item) => {
                    item.checked = false;
                })
            }
            // to remove all records from the array of document ids
            pullAll(documentsIdList, documentsIdList);
            pullAll(selectedIdsForDownload, selectedIdsForDownload);
        }
        this.setState({
            selectedIdsForMarkAsRead: documentsIdList,
            isSelectAllChecked: isChecked,
            checkedItemList: newCheckedList,
            selectedIdsForDownload
        });
    }

    filterCategoryList(listForRendering) {
        const {reports: {filterCategory}} =this.props;
        let list = []
        switch (filterCategory) {
            case FILTER_CATEGORY.READ:
                list = listForRendering.filter(res => res.read)
                break;
        
            case FILTER_CATEGORY.UNREAD:
                list = listForRendering.filter(res => !res.read)
                break;
        
            default:
                list  = [...listForRendering]
                break;
        }
        return list
    }

    /**
     * if cagtegory is selected as UNREAD in level 1/ report home screen,
     * then below method will be used to render report in accordion.
     * @param {*} reportList
     */
    renderUnreadCategoryListInAccordion = (reportList) => reportList.map((item, index) => {
        const isRowActive = this.state.activeAccordionItem.indexOf(index) !== -1;
        if (isRowActive) {
            itemsForRendering = item.documentMetadataList;
        }
        return (<AccordionItem
            active={isRowActive}
            className="ReportDocListAccordionItems UnreadDocAcc"
            renderTitle={() =>
                <ReportCategoryListHeader
                    categoryName={item.docCategoryName}
                    totalItems={item.documentMetadataList.length}
                    handleCategoryClick={() => this.handleCategoryClick(item.docCategoryId)}
                    isChecked={item.categoryChecked} />
            }
            style={{ color: '#a7a8aa' }}
            itemKey={index}
            key={item.docCategoryId}
        >
            {this.renderUnreadCategoryList(itemsForRendering, isRowActive, this.state.nextOffset)}
        </AccordionItem>);

    })

    /**
     * method to render unread cagtegory report list
     * @param {*} item
     */
    renderUnreadCategoryList = (list, isRowActive, nextOffset) => (
        <div style={{ position: 'relative' }}>
            <ReportUnreCategoryDocListItem
                handlePaginationChange={this.handlePaginationChange}
                isActive={isRowActive}
                categoryReportList={this.getDataForRendering(list)}
                nextOffset={nextOffset}
                showSeperator={false}
                handleReportItemClick={this.handleReportItemClick} />
        </div>
    )

    renderUnreadCategoryOneDocumentList = (reportList) => reportList.map((item, index) => (
        <div style={{ marginTop: 10 }}>
            <ReportCategoryDocListItem
                categoryReportList={
                    item.documentMetadataList}
                showSeperator={false}
                handleReportItemClick={this.handleReportItemClick} />
        </div>
    ))

    getTotalDocsForRange = () => {

        const {
            reports: {
                selectedReportDetailsDateRange,
            totalDocs7Days,
            totalDocs30Days,
            totalDocsCustomRange
            } } = this.props;
        let docsCount = 0;
        if (selectedReportDetailsDateRange === SELECTED_RANGE.CUSTOM) {
            docsCount = totalDocsCustomRange;
        }
        else if (selectedReportDetailsDateRange === SELECTED_RANGE.LAST_WEEK) {
            docsCount = totalDocs7Days;
        }
        else if (selectedReportDetailsDateRange === SELECTED_RANGE.LAST_MONTH) {
            docsCount = totalDocs30Days;
        }
        return docsCount;
    }


    /**
     * function to return report page header
     * (Select ALL and Show Unread Only options view)
     */
    getDoclistHeader = () => {
        const { reports: { selectedCategoryId } } = this.props;
        let isCategoryListEmpty = false;
        let isListAllUnreadOrRead = false;
        let metaData = [];
        const unreadCategorySelected = selectedCategoryId === EDELIVERY.UNREAD_CATEGORY_ID
        if (unreadCategorySelected) {
            if (this.state.unreadList.length <= 0) {
                isCategoryListEmpty = true;
            }
        } else if (this.state.selectedCategoryList) {
            metaData = (this.state.selectedCategoryList.documentMetadataList) ? this.filterCategoryList(this.state.selectedCategoryList.documentMetadataList) : [];
            if (metaData && metaData.length <= 0) {
                isCategoryListEmpty = true;
            }
            isListAllUnreadOrRead = metaData.length < 2 ||
                (metaData.length >= 2 && metaData.every((e, i) => i === 0 || e.read === metaData[i - 1].read))

        }

        // const count = this.getTotalDocsForRange();

        if (!isCategoryListEmpty ) {
            // if (selectedCategoryId === EDELIVERY.UNREAD_CATEGORY_ID) {
            //     return (
            //         <ReportCategorySelectAll isSelectAllChecked={this.state.isSelectAllChecked}
            //             isSelectAllIndeterminate={this.state.isSelectAllIndeterminate}
            //             handleSelectAllClick={this.handleSelectAllClick} />
            //     );
            // }
            const showUnreadOnly =
                !unreadCategorySelected && (this.state.isShowUnreadOnlyChecked || !isListAllUnreadOrRead)
            // const showUnreadOnly =  !unreadCategorySelected
            return (
                <ReportCategorySelectAll
                    showUnreadOnly={showUnreadOnly}
                    handleSelectAllClick={this.handleSelectAllClick}
                    handleShowUnreadOnlyClick={this.handleShowUnreadOnlyClick}
                    isSelectAllChecked={this.state.isSelectAllChecked}
                    isShowUnreadOnlyChecked={this.state.isShowUnreadOnlyChecked}
                />);
        }
    }

    /**
     * function to return mark as read view
     */
    getMarkAsReadView = () => {
        // if (this.state.selectedIdsForMarkAsRead.length > 0) {
        if ((this.state.selectedIdsForMarkAsRead.length > 0 || (this.state.selectedIdsForDownload.length > 0 && !this.state.individualDownload)) && this.filterCategoryList(this.state.selectedCategoryList.documentMetadataList).length > 0) {
            return (
                <View>
                    <ReportMarkReadOrDownload
                        downloadCount={this.state.selectedIdsForDownload.length}
                        markAsReadCount={this.state.selectedIdsForMarkAsRead.length}
                        handleMarkasReadOnclick={this.handleMarkasReadOnclick}
                        handlePreviewnDownloadClick={this.handlePreviewnDownloadClick}
                        downloadLoadingFlag={this.state.downloadLoadingFlag}
                    />
                </View>
            );
        }
    }

    /**
     * function to return report doclist body
     */
    getDocListBody = () => {
        const { reports: { selectedCategoryId, filterCategory } } = this.props;        

        // TODO:: check below condition with empty data.
        if (this.state.selectedCategoryList &&
            this.state.selectedCategoryList.documentMetadataList &&
            this.state.selectedCategoryList.documentMetadataList.length > 0 && this.filterCategoryList(this.state.selectedCategoryList.documentMetadataList).length > 0) {

            itemsForRendering = this.state.selectedCategoryList.documentMetadataList;
            return (<View style={{ paddingTop: 10 }}>

                {filterCategory && (<ReportCategoryDocListItem
                    nextOffset={this.state.nextOffset}
                    categoryReportList={
                        this.filterDataForRendering(itemsForRendering)}
                    showSeperator={false}
                    handleReportItemClick={this.handleReportItemClick} 
                    downloadIndividualReport={this.downloadIndividualReport}
                    />)}
            </View>);
        }
        // if no items in documentMetadataList then show no records found view
        return (<ReportEmptyData />);
    }

    /**
     * function: to set 7 days and 30 days count in level 2
     */
    setTotalDocs = (weekList, monthList, customRangeList) => {
        const weekData = weekList;
        const monthData = monthList;
        const customRangeData = customRangeList;
        const totalDocs7Days = this.getTotalDocs(weekData);
        const totalDocs30Days = this.getTotalDocs(monthData);
        const totalDocsCustomRange = this.getTotalDocs(customRangeData);
        this.props.setTotalDocs(totalDocs7Days, totalDocs30Days, totalDocsCustomRange);
    }

    getTotalDocs = (list) => {
        let totalDocs = 0;
        list.map((item) => {
            totalDocs += item.documentMetadataList.length;
        });
        return totalDocs;
    }



    downloadModalContent = () => {
        const { i18n: { messages }, reports: { pdfBinaryData, docIDforDownload }, getDocuments, setPdfBinaryData } = this.props;
        let documentName = '';

        for (let i = 0; i < Object.keys(this.state.checkedItemList).length; i++) {
            if (this.state.checkedItemList[i].documentId === docIDforDownload) {
                documentName = this.state.checkedItemList[i].documentName;
            }
        }

        if (!pdfBinaryData) {
            this.props.setBlurModalError(messages['app.chedelivery.reports.systemErrorMessage']);
        } else if (documentName !== '') {
            const isDownloaded = AttachmentDownload(documentName, pdfBinaryData);
            const url = 'data:application/pdf;base64,' + pdfBinaryData;
            if (!isDownloaded) {
                return (
                    <div className="pad-10">
                        <embed
                            src={url}
                            width="100%"
                            style={{ minHeight: this.props.screen.height - 75 }}
                        />
                    </div>
                );
            }
        }
        setPdfBinaryData('');
        let docIdIndex = '';
        for (let i = 0; i < this.state.selectedIdsForDownload.length; i++) {
            if (this.state.selectedIdsForDownload[i] === docIDforDownload) {
                docIdIndex = i;
            }
        }

        if (docIdIndex !== '') {
            docIdIndex += 1;
        }
        if (docIdIndex !== '' && this.state.selectedIdsForDownload[docIdIndex]) {
            this.props.downloadDocuments(this.state.selectedIdsForDownload[docIdIndex]);
        } else if (this.state.selectedIdsForDownload[docIdIndex] === undefined) {
            getDocuments();
        }
    }

    /**
 * function: closeBlurModel will update the state and hide the BlurModel
 */
    closeBlurModel = () => {
        this.setState({ hideWarning: true });
        this.props.setBlurModalError(null);
    };

    renderErrorModal = () => {
        const { reports: { blurModalError } } = this.props;
        return (
            <div className="row">
                <div className="small-12 text-center">
                    <div className="center">
                        <NotificationWarning color='#b92635' secondaryColor='#152139' width={50} height={50} />
                        <div className="pad-top-25 pad-bottom-25 center">
                            <div className="error-title">
                                <Text numberOfLines={1}>{blurModalError}</Text>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    /**
   * handle accordion item selection change
   */
    handleAccordionChange = (activeItems) => {
        // this.setState({
        //     nextOffset: 1,
        //     activeAccordionItem:''
        // })
        this.setState({
            nextOffset: 1,
            activeItems: [],
            activeAccordionItem: activeItems
        });
        this.props.activeItemChanged(true);
        if (this.rootView) {
            this.rootView.scrollTo({ y: 0 });
        }
    }
    /**
         * event to fire when scrollview is at the bottom
         * @param {*} param0
         */
    isScrollViewCloseToBottom({ layoutMeasurement, contentOffset, contentSize }) {
        return layoutMeasurement.height + contentOffset.y >= contentSize.height - 100;
    }

    /**
     * event to filer when scrollview is at the top
     */
    ifscrollViewCloseToTop({ layoutMeasurement, contentOffset, contentSize }) {
        // if (this.state.nextOffset )
        //     return false;
        return contentOffset.y <= 300 && (this.state.nextOffset > 10);// layoutMeasurement.height;
    }

    /**
     * event to handle scrollView next offset
     */
    loadNextOffestRecord = () => {
        const maxOffset = parseInt(itemsForRendering.length / ITEM_PER_PAGE);
        let nxtOffset = this.state.nextOffset;
        nxtOffset += 1;
        if (nxtOffset > maxOffset) {
            nxtOffset = this.state.nextOffset;
        }
        this.setState({ nextOffset: nxtOffset });
    }

    /**
     * event to handle scrollView previous offset
     */
    // loadPreviousOffestRecord = () => {
    //     const maxOffset = parseInt(itemsForRendering.length / ITEM_PER_PAGE);
    //     const nxtOffset = this.state.nextOffset;
    //     // 10 is the max number of offest, as total 100 records can be rendered at a time
    //     // 10 * ITEM_PER_PAGE
    //     if (nxtOffset > ITEM_PER_PAGE && nxtOffset <= maxOffset) {
    //         this.setState((prevState) => ({ nextOffset: prevState.nextOffset - 1 }));
    //         lastScrollPosition += 300;
    //     }

    //     // if (this.rootView)
    //     //     this.rootView.scrollTo({ y: 300 });
    // }


    enableBottomLoadingForScroll = () => {
        const maxOffset = parseInt(itemsForRendering.length / ITEM_PER_PAGE);
        if (itemsForRendering.length > ITEM_PER_PAGE && maxOffset !== this.state.nextOffset && (this.state.nextOffset > 1 || maxOffset > this.state.nextOffset)) {
            // this.props.setIsScrollLoading(true);
        }
    }

    getDataForRendering = (listForRendering) => {
        const list = listForRendering;
        const nextOffset = this.state.nextOffset;

        const itemCount = ITEM_PER_PAGE;
        const startIndex = 1;
        // const startIndex = (nextOffset > ITEM_PER_PAGE) ? ((nextOffset - ITEM_PER_PAGE)) * (itemCount) : 1;
        // const startIndex = (nextOffset > ) ? ((nextOffset - 5)) * (itemCount) : 1;
        const endIndex = nextOffset === 1 ? itemCount : (nextOffset * (itemCount));
        let slicedArray = [];
        // alert('startIndex ' + startIndex + '\nendIndex: ' + endIndex);

        if ((list && list.length > 0)) {
            slicedArray = [...list];
            // 1.  if there is only one record in the list checking with length 2 as this component is for items more than 1
            // 2.  if total length of slicedArray is less than endIndex and startIndex is 1
            if ((slicedArray.length <= itemCount) || (slicedArray.length <= endIndex) && (startIndex === 1)) {
                return slicedArray;
            }

            if (slicedArray.length <= startIndex) {
                return slicedArray;
            }

            // if slicedArray is containing array more than 10
            let sliceArray = slicedArray.slice(startIndex === 1 ? 0 : startIndex, endIndex);
            const leftItemsInList = list.slice(endIndex, list.length);
            if (leftItemsInList.length < ITEM_PER_PAGE) {
                sliceArray = sliceArray.concat(leftItemsInList);
            }
            slicedArray = sliceArray;
            return slicedArray;
        }
        this.props.reports.setShowSpinnerReport(false);
        return slicedArray;
    }

    filterDataForRendering = (listForRendering) => {
        const {reports: {filterCategory}} =this.props;

        let list = []
        switch (filterCategory) {
            case FILTER_CATEGORY.READ:
                list = listForRendering.filter(res => res.read)
                break;
        
            case FILTER_CATEGORY.UNREAD:
                list = listForRendering.filter(res => !res.read)
                break;
        
            default:
                list  = [...listForRendering]
                break;
        }
        
        return this.getDataForRendering(list)
    }

    updateReadUnreadState = (filter) => {
        this.setState({...this.state, isSelectAllChecked: false, selectedIdsForMarkAsRead: [],selectedIdsForDownload: []
        });

        this.props.reports.setFilterCategory(filter)

        // reset items checked in list
        this.setItemsAsCheckedOrUnchecked(false)
    }


    handlePaginationChange = () => {
        const {
            reports: { selectedCategoryId } } = this.props;
        if (this.rootView && selectedCategoryId !== EDELIVERY.UNREAD_CATEGORY_ID)
            this.rootView.scrollTo({ y: 0, animated: false });

    }

    setSrollViewPosition = (lastPosition) => {
        if (this.rootView) {
            this.rootView.scrollTo({ y: lastPosition || lastScrollPosition })
        }
    }


    handleScroll = (nativeEvent) => {
        alert('handling scroll')
    }

    render() {
        const { i18n: { messages }, reports: { blurModalError, pdfBinaryData } } = this.props;
        const {reports: {filterCategory, ShowSpinnerReport}} =this.props;

        // alert(this.state.selectedIdsForMarkAsRead);
        // if (this.state.selectedCategoryList && this.state.selectedCategoryList.length > 0 ||
        //     this.state.unreadList.length > 0) {

        if (pdfBinaryData !== '') {
            this.downloadModalContent();
        }

        // if (this.state.nextOffset === 1) {
        //     this.handlePaginationChange();
        // }

        if (blurModalError !== null) {
            return (
                <BlurModal
                    visible={this.state.hideWarning === false}
                    doneVisible={false}
                    title={messages['app.chedelivery.reports.systemErrorTitle']}
                    onDone={() => this.closeBlurModel()}
                >
                    {this.renderErrorModal()}
                </BlurModal>
            );
        }


        return (

            <div>
                <div className='buttons-container'>
                    <div className='buttons-container__left'>
                        {this.getDoclistHeader()}
                        {this.getMarkAsReadView()}
                    </div>
                    <div className='buttons-container__right'>
                        {this.props.daysSelectionComp()}
                        <div className="buttons">
                            <ButtonGroup>
                                <Button 
                                className="sec-button"
                                secondary={filterCategory != FILTER_CATEGORY.ALL} 
                                onPress={() => this.updateReadUnreadState(FILTER_CATEGORY.ALL)} size="large">
                                    {messages["app.trade.tradeoverview.tab.all"]}
                                </Button>
                                <Button 
                                onPress={() => this.updateReadUnreadState(FILTER_CATEGORY.UNREAD)} secondary={filterCategory != FILTER_CATEGORY.UNREAD} 
                                size="large" 
                                className="sec-button">
                                    {messages["app.chedelivery.reports.unread"]}
                                </Button>
                                <Button 
                                onPress={() => this.updateReadUnreadState(FILTER_CATEGORY.READ)} secondary={filterCategory != FILTER_CATEGORY.READ} 
                                size="large" 
                                className="sec-button">
                                    {messages["app.trade.label.read"]}
                                </Button>
                            </ButtonGroup>
                        </div>
                    </div>
                </div>
                
                <div id="container_reports_reportCategoryDoclist_test" className="scrollBarHover" style={{ width: '100%' }}>
                    {
                        (this.state.selectedCategoryList &&
                            this.state.selectedCategoryList.documentMetadataList &&
                            this.state.selectedCategoryList.documentMetadataList.length > 0 && this.filterCategoryList(this.state.selectedCategoryList.documentMetadataList).length > 0) && (
                            <React.Fragment>
                                <View style={StyleSheet.flatten(additionalStyles.tableRoot)}>
                                    <View style={StyleSheet.flatten(additionalStyles.containerParent)}>
                                        <View style={StyleSheet.flatten(additionalStyles.checkbox)}></View>
                                        <View style={StyleSheet.flatten(additionalStyles.reportName)}>
                                        <Large secondary>{messages['app.reports.reportHeader']}</Large>
                                        </View>
                                        <View style={StyleSheet.flatten(additionalStyles.portfolio)}>
                                        <Large secondary>{messages['app.chedelivery.reports.accountPortfolioLabel']}</Large>
                                        </View>
                                        <View style={StyleSheet.flatten(additionalStyles.date)}>
                                        <Large secondary>{messages['app.report.transactionHistory.tradeDate']}</Large>
                                        </View>
                                        <View style={StyleSheet.flatten(additionalStyles.preview)}>
                                        <Large secondary>{messages['app.chedelivery.reports.preview']}</Large>
                                        </View>
                                        <View style={StyleSheet.flatten(additionalStyles.download)}>
                                        <Large secondary>{messages['app.chedelivery.reports.download']}</Large>
                                        </View>
                                    </View>
                                </View>
                            </React.Fragment>
                        )
                    }
                    {ShowSpinnerReport && <View>
                                <ActivityIndicator animating
                                    color={"#00a7f0"}
                                    size="large"/>
                                </View>}
                    <ScrollView
                        ref={(rootView) => {
                            this.rootView = rootView
                        }}
                        className="scrollBarHide" id="scrollBarHide"
                        scrollEventThrottle={16}
                        onContentSizeChange={() => {
                            if (this.state.nextOffset > 10)
                                this.setSrollViewPosition(lastScrollPosition);
                        }
                        }
                        style={{ overflowX: "hidden", maxHeight: "500px",minHeight:"400px",
                         width: '100%' }}
                        scrollEnabled
                        onScroll={({ nativeEvent }) => {
                            this.enableBottomLoadingForScroll();
                            const currentOffset = nativeEvent.contentOffset.y;
                            const direction = currentOffset > this.offset ? SCROLL_DIRECTION.DOWN : SCROLL_DIRECTION.UP;
                            this.offset = currentOffset;

                            lastScrollPosition = nativeEvent.contentOffset.y;

                            if (direction === SCROLL_DIRECTION.UP && this.state.nextOffset > 1) {
                                if (this.ifscrollViewCloseToTop(nativeEvent)) {
                                    // this.loadPreviousOffestRecord();
                                }
                            }

                            if (this.isScrollViewCloseToBottom(nativeEvent)) {
                                this.loadNextOffestRecord();
                            }
                        }}
                    >
                        
                        <div>
                            {this.getDocListBody()}
                        </div>
                    </ScrollView>
                </div>
            </div>
        );
        // }
        // return (<ReportEmptyData />)
    }
}

ReportCategoryDocList.propTypes = {
    i18n: PropTypes.shape({
        messages: PropTypes.object,
    }),
    isSelectAllChecked: PropTypes.bool,
    isSelectAllIndeterminate: PropTypes.bool,
    isCategoryChecked: PropTypes.bool,
    isShowUnreadOnlyChecked: PropTypes.bool,
    selectedIdsForMarkAsRead: PropTypes.array,
    selectedCategoryList: PropTypes.array,
    unreadList: PropTypes.array,
    showMarkAsRead: PropTypes.bool,
}

ReportCategoryDocList.defaultProps = {
    i18n: {},
    isSelectAllChecked: false,
    isSelectAllIndeterminate: false,
    isCategoryChecked: false,
    isShowUnreadOnlyChecked: false,
    selectedIdsForMarkAsRead: [],
    selectedCategoryList: [],
    unreadList: [],
    showMarkAsRead: [],
}


export default createContainer(
    {
        $renderLoading: () => <LoadingCircle />,
        $queries: {
            app: {
                config: {
                    apiverion: true
                },
                user: {
                    selectedPortfolio: true
                }
            },
            edelivery: {
                getUserPreferences: { $call: 'getUserPreferences' },
                showPrompt: true,
            },
            settings: {
                currentEnvironment: {
                    remoteUrl: true,
                },
            },
            auth: {
                userId: true,
                authHeader: true,
                langCode: true
            },
            changePage: { $call: 'ui.history.push' },
            i18n: {
                messages: true,
            },
            getDocuments: {
                $call: 'reports.getDocuments',
            },
            getLastStatements: {
                $call: 'reports.getLastStatements',
            },
            markDocumentAsCheckedOrUnchecked: {
                $call: 'reports.markDocumentAsCheckedOrUnchecked'
            },
            markDocumentsAsRead: {
                $call: 'reports.markDocumentsAsRead'
            },
            downloadDocuments: {
                $call: 'reports.downloadDocuments'
            },
            setTotalDocs: {
                $call: 'reports.setTotalDocs'
            },
            setBlurModalError: {
                $call: 'reports.setBlurModalError'
            },
            setPdfBinaryData: {
                $call: 'reports.setPdfBinaryData'
            },
            setDownloadDocId: {
                $call: 'reports.setdocIDforDownload'
            },
            setShowSpinner: {
                $set: 'reports.showSpinner'
            },
            setShowSpinnerReport: {
                $set: 'reports.ShowSpinnerReport'
            },
            setIsScrollLoading: {
                $set: 'reports.isScrollLoading'
            },
            activeItemChanged: {
                $set: 'reports.isActiveItemChanged'
            },
            getCustomRangeDocuments: {
                $call: 'reports.fetchDocumentsForCategories'
            },
            reports: {
                blurModalError: true,
                docIDforDownload: true,
                pdfBinaryData: true,
                showSpinner: true,
                ShowSpinnerReport: true,
                lastMonthStatements: true,
                filterCategory: true,
                statement: {
                    lastWeek: true,
                    lastWeekTotalUnreadDocs: true,
                    lastMonth: true,
                    lastMonthTotalUnreadDocs: true,
                    lastWeekUnread: true,
                    lastMonthUnread: true,
                    customRangeList: true,
                    customRangeUnreadList: true,
                    last90days: true

                },
                totalDocs7Days: true,
                totalDocs30Days: true,
                totalDocsCustomRange: true,
                selectedCategoryId: true,
                selectedReportDetailsDateRange: true,
                setShowUnreadOnlyChecked: {
                    $set: 'showUnreadOnlyChecked',
                },
                setFilterCategory:{
                    $set: 'filterCategory'
                },
                startDate: true,
                endDate: true,

            },
            getStatementPdf: {
                $call: 'monthly.getPdf',
            },
            dailyPdf: {
                pdf: true,
                setEmpty: { $set: 'pdf' },
            },
            resetAdvicesDates: { $call: 'advices.resetDates' },
            resetReportsDates: { $call: 'reports.resetDates' },
            portfolio: {
                netIncome: {
                    value: true,
                },
            },
        },
    },
)(ReportCategoryDocList);
